import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import AuthContext from "../context/auth/AuthContext";

const TenantModuleRoute = ({ children, moduleKey }) => {
  const { isModuleEnabled } = useContext(AuthContext);

  if (!isModuleEnabled?.(moduleKey)) {
    return <Navigate to="/" replace />;
  }

  return children ?? <Outlet />;
};

export default TenantModuleRoute;
